import { createContext, useContext, useEffect, useState } from "react";

const ZoomContext = createContext(null);
const LS_KEY = "omni-zoom";
const MIN = 50, MAX = 200, STEP = 10;

export function ZoomProvider({ children }) {
  const [zoom, setZoom] = useState(() => {
    const v = parseInt(localStorage.getItem(LS_KEY) || "100", 10);
    return Number.isFinite(v) ? v : 100;
  });

  useEffect(() => {
    document.documentElement.style.fontSize = `${zoom}%`;
    localStorage.setItem(LS_KEY, String(zoom));
  }, [zoom]);

  const inc = () => setZoom((z) => Math.min(MAX, z + STEP));
  const dec = () => setZoom((z) => Math.max(MIN, z - STEP));
  const reset = () => setZoom(100);

  return (
    <ZoomContext.Provider value={{ zoom, inc, dec, reset, setZoom, MIN, MAX }}>
      {children}
    </ZoomContext.Provider>
  );
}

export function useZoom() {
  const v = useContext(ZoomContext);
  if (!v) throw new Error("useZoom must be used inside <ZoomProvider>");
  return v;
}
